var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-exam"},[_c('p',{staticClass:"e-exam-title"},[_vm._v("期末考试")]),(_vm.topics)?_c('div',{staticClass:"e-exam-drys"},_vm._l((_vm.topics),function(topic,topicIndex){return _c('dry',{key:topicIndex,attrs:{"index":topicIndex,"content":topic.content,"course":topic.course}})}),1):_c('loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }